import React from "react";
import { useTranslation } from "react-i18next";
import { quotedClient } from "../content/clients";
import "../styles/home.css";

/**
 * Client quote #clients (spec c.7 §7): one consented quote with a named person and
 * title, or nothing at all. Today no client has quoteConsent, so this renders null and
 * the section, its anchor and any link to it are absent. Logos live in the proof strip.
 */
const Clients: React.FC = () => {
  const { t } = useTranslation();
  const client = quotedClient();
  if (!client?.quote) return null;
  const { quote } = client;

  return (
    <section id="clients" className="section" aria-labelledby="clients-heading">
      <div className="container">
        <div className="client-quote">
          <h2 id="clients-heading" className="visually-hidden">
            {t("testimonials.srTitle")}
          </h2>
          <p className="t-label" aria-hidden="true">
            {t("testimonials.label")}
          </p>
          <figure>
            <blockquote className="t-quote">
              <p>{t(quote.textKey)}</p>
            </blockquote>
            <figcaption>
              {client.logoConsent && (
                <img
                  className="client-quote-logo"
                  src={client.logo}
                  alt={client.name}
                  height={28}
                  width={Math.round((client.logoWidth / client.logoHeight) * 28)}
                  loading="lazy"
                  decoding="async"
                />
              )}
              <span>
                <span className="client-quote-person">{quote.person}</span>
                <span className="t-small client-quote-title">
                  {t(quote.titleKey)}, {client.name}
                </span>
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Clients;
